import validate from "/Users/federicaprincipe/IdeaProjects/Paradigma/pdg-website/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {}